import { HorizontalRule, cssColorValue, semanticColors } from '@spotify-internal/encore-web';
import React, { Fragment, useEffect } from 'react';
import styled from 'styled-components';

import { NavBarPopoverNavigation } from 'components/Masthead/Header/Popover/Shared';
import { isMastheadLinkList } from 'utils/type-guards';
import { isLinkVisible } from 'components/Masthead/shared/utils';
import { NavbarPopoverItem } from 'components/Masthead/Header/Popover/PopoverItem';
import { NavBarPopoverListItem } from 'components/Masthead/Header/Popover/LinkItem';
import { MastheadLinkOrLinkListArray } from 'lib/sanity/types';
import { useUbiMastheadHeader } from 'utils/ubi/pages/useUbiHeader';

interface Props {
  profileLinks: MastheadLinkOrLinkListArray;
  isLoggedIn: boolean;
}

const Divider = styled(HorizontalRule)`
  background-color: ${cssColorValue(semanticColors.backgroundTintedHighlight)};
  margin-block: 8px;
  &:last-of-type {
    display: none;
  }
`;

export const NavBarProfileLinksPopoverOverlay = ({ isLoggedIn, profileLinks }: Props) => {
  const ubi = useUbiMastheadHeader();

  const onProfileLinkClick = (identifier: string, uri: string) => {
    ubi.logProfileLinkInteraction({ container: 'header', identifier, uri });
  };

  useEffect(() => {
    ubi.logProfileLinksContainerImpression('header');
  }, [ubi]);

  return (
    <NavBarPopoverNavigation>
      {profileLinks
        .filter(item => isMastheadLinkList(item) || isLinkVisible(item, isLoggedIn))
        .map(item => {
          return (
            <Fragment key={item._key}>
              {isMastheadLinkList(item) ? (
                <NavbarPopoverItem
                  linkListEntry={item}
                  isLoggedIn={isLoggedIn}
                  onClick={link => {
                    onProfileLinkClick(link.trackingID, link.href);
                  }}
                />
              ) : (
                <NavBarPopoverListItem
                  {...item}
                  onClick={() => {
                    onProfileLinkClick(item.trackingID, item.href);
                  }}
                  nestingLevel={1}
                />
              )}
              <Divider />
            </Fragment>
          );
        })}
    </NavBarPopoverNavigation>
  );
};
